import React, { useEffect, useState } from 'react'
import { Alert, Button, Checkbox, Drawer, Form, Input, message, notification, Popconfirm, Tag } from 'antd'
import {
    PlusOutlined,
    SaveOutlined,
    EditOutlined,
    DeleteOutlined,
} from '@ant-design/icons';
import Container from '../../../components/Container'
import Main from '../../../components/Main'
import PageHeader from '../../../components/PageHeader'
import AgoraTable from '../../../components/Table';
import { useAuthUser } from 'react-auth-kit';
import axios from 'axios';

function PurchaseOrg() {
    const auth = useAuthUser()
    const [purchaseOrgForm] = Form.useForm();
    const [state, setState] = useState({
        gvPurchaseOrgLoading: false,
        gvPurchaseOrg: [],
        formOpen: false,
        formType: "Add",
        btnSubmitLoading: false,
        btnSubmitResStatus: "",
        btnSubmitResMsg: "",
        btnDeleteLoading: false,
    })
    const handleSetState = (newState) => {
        setState(prevState => ({
            ...prevState,
            ...newState,
        }))
    }
    useEffect(() => {
        getPurchaseOrgPageLoad()
        // eslint-disable-next-line
    }, [])
    const getPurchaseOrgPageLoad = () => {
        handleSetState({ gvPurchaseOrgLoading: true })
        axios.get(`/PurchaseOrg/PageLoad`).then(res => {
            let resData = res.data
            if (resData.Status === "True") {
                handleSetState({
                    gvPurchaseOrgLoading: false,
                    gvPurchaseOrg: resData.Data.gvPurchaseOrg
                })
                return resData.Data
            } else {
                message.error(resData.Message)
            }
        }).catch(error => {
            console.log(error)
            message.error(error.message)
        })
    }
    const handleOnFinishPurchaseOrg = (formData) => {
        handleSetState({ btnSubmitLoading: true })
        if (state.formType === "Add") {
            axios.post(`/PurchaseOrg/Create`, {
                purchaseOrgCode: formData.purchaseOrgCode,
                purchaseOrgDesc: formData.purchaseOrgDesc,
                purchaseOrgDefault: formData.purchaseOrgDefault,
                createdBy: auth().userId,
            }).then(res => {
                let resData = res.data
                if (resData.Status === "True") {
                    handleSetState({
                        formOpen: false,
                        btnSubmitLoading: false
                    });
                    getPurchaseOrgPageLoad();
                    notification.success({
                        message: "Successful",
                        description: resData.Message
                    });
                } else {
                    handleSetState({
                        btnSubmitLoading: false,
                        btnSubmitResStatus: resData.Status,
                        btnSubmitResMsg: resData.Message,
                    });
                }
            }).catch(error => {
                console.log(error);
                message.error(error.message);
            })
        } else if (state.formType === "Edit") {
            axios.post(`/PurchaseOrg/Update`, {
                purchaseOrgId: formData.purchaseOrgId,
                purchaseOrgCode: formData.purchaseOrgCode,
                purchaseOrgDesc: formData.purchaseOrgDesc,
                purchaseOrgDefault: formData.purchaseOrgDefault,
                modifiedBy: auth().userId,
            }).then(res => {
                let resData = res.data
                if (resData.Status === "True") {
                    handleSetState({
                        formOpen: false,
                        btnSubmitLoading: false
                    });
                    getPurchaseOrgPageLoad();
                    notification.success({
                        message: "Successful",
                        description: resData.Message
                    });
                } else {
                    handleSetState({
                        btnSubmitLoading: false,
                        btnSubmitResStatus: resData.Status,
                        btnSubmitResMsg: resData.Message,
                    });
                }
            }).catch(error => {
                console.log(error);
                message.error(error.message);
            })
        }

    }
    const handleOnDeletePurchaseOrg = () => {
        handleSetState({ btnDeleteLoading: true })
        axios.post(`/PurchaseOrg/Delete`, {
            purchaseOrgId: purchaseOrgForm.getFieldValue("purchaseOrgId"),
            modifiedBy: auth().userId,
        }).then(res => {
            let resData = res.data
            if (resData.Status === "True") {
                handleSetState({
                    formOpen: false,
                    btnDeleteLoading: false
                });
                getPurchaseOrgPageLoad();
                notification.success({
                    message: "Successful",
                    description: resData.Message
                });
            } else {
                handleSetState({
                    btnDeleteLoading: false,
                    btnSubmitResStatus: resData.Status,
                    btnSubmitResMsg: resData.Message,
                });
            }
        }).catch(error => {
            console.log(error);
            message.error(error.message);
        })

    }

    const isAllowToManage = () => {
        if (auth().role === "Admin") {
            return true
        }
        return false;
    }

    return (
        <Main listBreadcrumb={[
            { key: "1", title: "Maintenance" },
            { key: "2", title: "Library" },
            { key: "3", title: "Purchasing Organization" },
        ]}>
            <Container>
                <PageHeader title="Purchasing Organization" subtitle="List of purchasing organization details.">
                    {isAllowToManage() &&
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => {
                                purchaseOrgForm.resetFields();
                                handleSetState({
                                    formOpen: true,
                                    formType: "Add",
                                })
                            }}
                        >
                            New Purchasing Organization
                        </Button>
                    }
                </PageHeader>
                <AgoraTable
                    loading={state.gvPurchaseOrgLoading}
                    dataSource={state.gvPurchaseOrg}
                    rowKey="purchaseOrgId"
                    columns={[
                        {
                            title: 'Purchasing Organization Code',
                            dataIndex: 'purchaseOrgCode',
                            key: 'purchaseOrgCode',
                            dataType: "text",
                            render: (text, record) => <div className="i-x-space-between">
                                <div className='i-x-left i-y-center'>
                                    {text || "-"}
                                    {record.purchaseOrgDefault && <Tag color="blue" style={{ marginLeft: "10px" }}>Default</Tag>}
                                </div>
                                <div className="i-x-right">
                                    {isAllowToManage() && <Button className="table-btn edit" size="small" style={{ marginRight: "10px" }}
                                        onClick={() => {
                                            purchaseOrgForm.setFieldsValue({
                                                purchaseOrgId: record.purchaseOrgId,
                                                purchaseOrgCode: record.purchaseOrgCode,
                                                purchaseOrgDesc: record.purchaseOrgDesc,
                                                purchaseOrgDefault: record.purchaseOrgDefault,
                                            });
                                            handleSetState({
                                                formOpen: true,
                                                formType: "Edit",
                                            })
                                        }}
                                    ><EditOutlined /> Edit</Button>
                                    }
                                </div>
                            </div>,
                        },
                        {
                            title: 'Description',
                            dataIndex: 'purchaseOrgDesc',
                            key: 'purchaseOrgDesc',
                            dataType: "text",
                            render: (text) => text || "-",
                        },
                    ]}
                />
            </Container>
            <Drawer title={`${state.formType} Purchasing Organization`}
                width={window.innerWidth > 500 ? 500 : window.innerWidth - 80}
                open={state.formOpen}
                extra={
                    <Button type="primary"
                        loading={state.btnSubmitLoading}
                        onClick={() => purchaseOrgForm.submit()}
                        icon={state.formType === "Add" ? <PlusOutlined /> : <SaveOutlined />}
                    >
                        {state.formType === "Add" ? "Add" : "Update"}
                    </Button>
                }
                onClose={() => {
                    purchaseOrgForm.resetFields()
                    handleSetState({
                        formType: "Add",
                        formOpen: false,
                        btnSubmitResStatus: "",
                        btnSubmitResMsg: "",
                    })
                }}
            >
                <div className="i-y-100 i-y-space-between">
                    <Form
                        form={purchaseOrgForm}
                        name="purchasing-organization-form"
                        layout="vertical"
                        size="middle"
                        requiredMark={false}
                        onFinish={handleOnFinishPurchaseOrg}
                    >
                        {state.btnSubmitResStatus !== ""
                            && <Alert type="error" showIcon style={{ margin: "0px 25px 20px 0px" }}
                                message={state.btnSubmitResMsg}
                            />
                        }
                        <Form.Item hidden={true} name="purchaseOrgId" ></Form.Item>
                        <Form.Item
                            label="Purchasing Organization Code"
                            name="purchaseOrgCode"
                            tooltip="This is a required field"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter purchasing organization code!',
                                },
                            ]}
                        >
                            <Input placeholder='e.g., SGD' />
                        </Form.Item>
                        <Form.Item
                            label="Description"
                            name="purchaseOrgDesc"
                            tooltip="This is a required field"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter purchasing organization description!',
                                },
                            ]}
                        >
                            <Input placeholder='e.g., Singapore Dollar' />
                        </Form.Item>
                        <Form.Item name="purchaseOrgDefault" valuePropName="checked" noStyle>
                            <Checkbox>Set as Default</Checkbox>
                        </Form.Item>
                    </Form>
                    {state.formType === "Edit"
                        ? <div>
                            <Popconfirm
                                title="Delete purchasing organization"
                                description="Are you sure to delete this purchasing organization?"
                                onConfirm={handleOnDeletePurchaseOrg}
                                okText="Yes"
                                okType="danger"
                            >
                                <Button type="primary" danger block loading={state.btnDeleteLoading}
                                    icon={<DeleteOutlined />}
                                >Delete Purchasing Organization</Button>
                            </Popconfirm>
                        </div>
                        : ""
                    }
                </div>
            </Drawer>
        </Main>
    )
}

export default PurchaseOrg